import $ from 'jquery'

function init () {
  $('footer .back-to-top-container .back-to-top').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  })
}

export default {
  init
}
